document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".reviews-carousel", {
    slidesPerView: 2,
    spaceBetween: 12,
    centeredSlides: true,
    initialSlide: 1,
    navigation: {
      nextEl: ".reviews-swiper-button-next",
      prevEl: ".reviews-swiper-button-prev",
    },
    breakpoints: {
      769: {
        initialSlide: 0,
      },
    },
  });
});
